package com.zq.webproject.utils

import kotlinx.browser.window
import kotlin.random.Random

/**
 * JS/Web平台设备工具类实现
 */
actual object DeviceUtils {
    private var cachedDeviceId: String? = null
    
    /**
     * 获取设备唯一标识
     * Web平台使用localStorage持久化UUID
     */
    actual fun getDeviceId(): String {
        println("DeviceUtils [Web] - getDeviceId() 被调用")
        
        // 如果已经缓存，直接返回
        cachedDeviceId?.let {
            println("DeviceUtils [Web] - 返回缓存的设备ID: $it")
            return it
        }
        
        return try {
            println("DeviceUtils [Web] - 尝试从localStorage读取")
            // 尝试从localStorage读取
            val storage = window.localStorage
            var deviceId = storage.getItem("device_id")
            
            if (deviceId.isNullOrEmpty()) {
                // 生成新的UUID
                println("DeviceUtils [Web] - localStorage中无设备ID，生成新UUID")
                deviceId = generateUUID()
                storage.setItem("device_id", deviceId)
                println("DeviceUtils [Web] - 生成并保存新设备ID: $deviceId")
            } else {
                println("DeviceUtils [Web] - 使用已保存的设备ID: $deviceId")
            }
            
            cachedDeviceId = deviceId
            println("DeviceUtils [Web] - 最终返回设备ID: $deviceId")
            deviceId
        } catch (e: Exception) {
            println("DeviceUtils [Web] - 获取设备ID异常: ${e.message}")
            e.printStackTrace()
            val fallbackId = generateUUID()
            cachedDeviceId = fallbackId
            println("DeviceUtils [Web] - 返回备用UUID: $fallbackId")
            fallbackId
        }
    }
    
    /**
     * 获取设备名称（浏览器信息）
     */
    actual fun getDeviceName(): String {
        return try {
            val userAgent = window.navigator.userAgent
            parseBrowserName(userAgent)
        } catch (e: Exception) {
            println("DeviceUtils - 获取设备名称失败: ${e.message}")
            "Web Browser"
        }
    }
    
    /**
     * 获取设备类型
     */
    actual fun getDeviceType(): String {
        return "web"
    }
    
    /**
     * 生成UUID（简化版）使用Kotlin Random
     */
    private fun generateUUID(): String {
        val hexChars = "0123456789abcdef"
        val sb = StringBuilder()
        
        for (i in 0 until 36) {
            when (i) {
                8, 13, 18, 23 -> sb.append('-')
                14 -> sb.append('4') // UUID version 4
                19 -> {
                    // UUID variant
                    val r = Random.nextInt(4)
                    sb.append(hexChars[8 + r])
                }
                else -> {
                    val r = Random.nextInt(16)
                    sb.append(hexChars[r])
                }
            }
        }
        
        return sb.toString()
    }
    
    /**
     * 解析浏览器名称
     */
    private fun parseBrowserName(userAgent: String): String {
        return when {
            userAgent.contains("Firefox") -> "Firefox"
            userAgent.contains("Chrome") && !userAgent.contains("Edg") -> "Chrome"
            userAgent.contains("Edg") -> "Edge"
            userAgent.contains("Safari") && !userAgent.contains("Chrome") -> "Safari"
            userAgent.contains("Opera") || userAgent.contains("OPR") -> "Opera"
            else -> "Web Browser"
        }
    }
}
